import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';

export const Walk = () => <DirectionsWalkIcon fontSize="small" />;
